export default __webpack_public_path__ + "static/media/syrups.88dbc600.svg";